// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__TdU5W","card":"index_card__2yePd","logo":"index_logo__3ldBT"};